module.exports = __webpack_public_path__ + "static/img/73.6d98823.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/73.png
// module id = izkW
// module chunks = 1